/**
 * @file:
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/11/20      1.0     First version  默认两个可供输入，不限制新增数量；同一个联系方式，可以有多个，但是值不能相同
 *
 * 注意：
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React, {PureComponent} from "react";
import {Spin,Space,Select,Input,Button,message} from 'antd';
import Lang from "@/components/Lang/Lang";
import "./index.less"

export default class OtherConnect extends PureComponent {
    static defaultProps = {
        socialMediaList: [], // 显示
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            im_type_list:__getDictList("im_type")||[],
            list:[
                {
                    id:0,
                    mediaTypeCode:null,
                    mediaDetail:""
                },
            ]
        }
        this.canSave = true;
    }
    /*
    * 新增一个联系广式
    * */
    addConnect(){
        const {list=[], } = this.state;
        let newList = [...list];
        const iLen = list.length>0?list[list.length-1].id:0;
        newList.push({
            id:iLen+1
        })
        this.setState({
            list:  newList,
        })
    }
    /*
    * 行编
    * */
    onChange(id,field,value="",vValue="") {
        const {list=[]} = this.state;
        if(field=="mediaTypeCode"&&vValue){
            const someItems = list.filter(item=>item.mediaTypeCode==value&&item.mediaDetail==vValue);
            if(someItems&&someItems.length>0){
                // message.warning(Lang({id:"LianXiFangShiYiCunZai"}));//联系方式已存在，请重新输入
                message.warning(Lang({id:"LianXiFangShiYiCunZai"}),3,()=>{
                    this.canSave = true;
                });//联系方式已存在，请重新输入
                this.canSave = false;
                return false
            }
        }
        let newList = [...list];
        let curItem = newList.find(item=>item.id==id);
        curItem[field]=value;
        this.setState({
            list:  newList
        })
    }
    delete(id){
        const {list=[]} = this.state;
        let newList = [...list];
        const someItems = newList.filter(item=>item.id!=id);
        this.setState({
            list:  someItems||[]
        })
    }
    /*
     * 校验数据
     * */
    onCheck(id,field,mediaTypeCode,value="") {
        if(mediaTypeCode&&value){
            const {list=[]} = this.state;
            const someItems = list.filter(item=>item.mediaTypeCode==mediaTypeCode&&item.mediaDetail==value);
            if(someItems&&someItems.length>1){
                message.warning(Lang({id:"LianXiFangShiYiCunZai"}),3,()=>{
                    this.canSave = true;
                });//联系方式已存在，请重新输入
                this.canSave = false;
                let newList = [...list];
                let curItem = newList.find(item=>item.id==id);
                curItem[field]=null;
                this.setState({
                    list:  newList
                })
            }
        }
    }
    /*
    * 未对接
    * */
    handleOK(){
        const {list=[]} = this.state;
        // 返回两项都有值的数据
        const someItems = list.filter(item=>item.mediaTypeCode&&item.mediaDetail);
        return {
            success: this.canSave,
            list: someItems
        }
    }
    componentDidMount() {
        if(this.props.socialMediaList){
            let socialMediaList =this.props.socialMediaList;
            if(socialMediaList.length>0){
                socialMediaList.forEach((item={},i)=>item.id = i)
                this.setState({
                    list: socialMediaList
                })
            }
            // else if(socialMediaList.length==1){
            //     socialMediaList.forEach((item={},i)=>item.id = i);
            //     socialMediaList.push(   {
            //         id:1,
            //         mediaTypeCode:null,
            //         mediaDetail:null
            //     })
            //     this.setState({
            //         list: socialMediaList
            //     })
            // }
        }
        if (this.props.onRef) this.props.onRef(this);

    }
    render() {
        const {loading = true,im_type_list,list=[]} = this.state;
        return (<Spin spinning={loading}>
            <div className={"mb_8"}>
                <Lang id="QiTaLianXiFangShi">其他联系方式</Lang>
                <Button type="primary" onClick={()=>this.addConnect()} className={"btn-primary-blue ml_12"}>
                    <Lang id="XinZeng">新增</Lang>
                </Button>
            </div>
            <div className={"otherConnectWrap"}>
                {list.map((item)=><div className={"flex-item-ver-center mr_40 mb_8"} key={"otherConnect_"+item.id}>
                    <Space.Compact>
                        <Select options={im_type_list} fieldNames={{label:"name",value:"code"}} style={{width:"120px",background:"#F2F2F5"}}
                                value={item.mediaTypeCode||null}
                                onChange={(v)=>this.onChange(item.id,"mediaTypeCode",v,item.mediaDetail)}
                                placeholder={Lang({id:'QingXuanZe2',default:"请选择"})} />
                        <Input style={{width:"190px"}}
                               value={item.mediaDetail||null}
                               onChange={(e)=>this.onChange(item.id,"mediaDetail",e.target.value)}
                               onBlur={(e)=>this.onCheck(item.id,"mediaDetail",item.mediaTypeCode,item.mediaDetail)}
                               placeholder={Lang({id:'QingShuR',default:"请输入"})} />
                    </Space.Compact>
                    <span className={"ri-delete-bin-line color-red2 font_20 ml_8 cursor-p"} onClick={()=>this.delete(item.id)}/>
                </div>)}
                {/*<div className={"flex-item-ver-center mb_8"}>*/}
                    {/*<Space.Compact>*/}
                    {/*<Select options={im_type_list} fieldNames={{label:"name",value:"code"}} style={{width:"120px",background:"#F2F2F5"}} placeholder={Lang({id:'QingXuanZe2',default:"请选择"})}/>*/}
                    {/*<Input style={{width:"190px"}} placeholder={Lang({id:'QingShuR',default:"请输入"})} />*/}
                    {/*</Space.Compact>*/}
                    {/*<span className={"ri-delete-bin-line color-red2 font_20 ml_8"} />*/}
                {/*</div>*/}
            </div>
        </Spin>);
    }
}
